export const CloverRpaModuleName = {
    CLOVER_IPG: 'clover-ipg' as const,
} as const;

export type CloverRpaModuleName = (typeof CloverRpaModuleName)[keyof typeof CloverRpaModuleName];
